import React, { FC, useMemo } from 'react';
import styles from './styles.module.less';
import { PercentIndicator } from 'components/Statistic';
import { useUserPnl } from 'api/dashboard';
import clsx from 'clsx';

import { useAppSelector, useTypeSafeTranslation } from 'hooks';
import numeral from 'numeral';
import { Space } from 'antd';
import { getCurrentCurrency } from 'store/ducks/account/slice';
import { HIDE_PNL } from 'utils/constant';

const numberFormater = (number: any) => {
  if (Number(number) > 999999) {
    return numeral(number).format('0,0[.]00a');
  }
  return numeral(number).format('0,0[.]000');
};

const UserPnl: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTypeSafeTranslation();
  const { data } = useUserPnl();
  const currentCurrency = useAppSelector(getCurrentCurrency);

  const localAsset = useMemo(() => {
    return {
      asset: numberFormater(Number(data?.assetYesterday) * Number(currentCurrency.rate) || 0),
      currency: currentCurrency.coinType,
      symbol: currentCurrency.symbol,
    };
  }, [data, currentCurrency]);

  if (HIDE_PNL) {
    return null;
  }

  return (
    <div className={clsx(styles.pnlBox, className)}>
      <p className="disabled nowrap">{t('common.yesterday_pnl')}</p>
      <Space direction="vertical" align="end">
        <div className={styles.pnl}>
          <span suppressHydrationWarning className={styles.symbol}>
            {localAsset.symbol}&nbsp;
          </span>
          <span className={styles.asset}>{localAsset.asset}</span>
        </div>
        <PercentIndicator value={`${numeral(data?.percent).format('0[.][000]') || 0}%`} />
      </Space>
    </div>
  );
};

export default UserPnl;
